import "@fontsource/montserrat";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ReactGA from "react-ga";
import { GoogleOAuthProvider } from '@react-oauth/google';

import B2BLayout from "./NewDesign/Components/B2B/B2BLayout";
import HomePage from "./NewDesign/Components/B2B/pages/HomePage";
import BacPage from "./NewDesign/Components/B2B/pages/BacPage";
import ResultsPage from "./NewDesign/Components/B2B/pages/ResultsPage";
import ImplementationPage from "./NewDesign/Components/B2B/pages/ImplementationPage";
import PrivacyPage from "./NewDesign/Components/B2B/pages/PrivacyPage";
import TermsPage from "./NewDesign/Components/B2B/pages/TermsPage";

const TRACKING_ID = "G-5TSZG25VY0";
ReactGA.initialize(TRACKING_ID);

const Router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <title>Yo Me Controlo</title>
        <B2BLayout><HomePage /></B2BLayout>
      </>
    ),
  },
  {
    path: "/bac",
    element: (
      <>
        <title>YMC | BAC</title>
        <B2BLayout><BacPage /></B2BLayout>
      </>
    ),
  },
  {
    path: "/resultados",
    element: (
      <>
        <title>YMC | Resultados</title>
        <B2BLayout><ResultsPage /></B2BLayout>
      </>
    ),
  },
  {
    path: "/implementacion",
    element: (
      <>
        <title>YMC | Implementación</title>
        <B2BLayout><ImplementationPage /></B2BLayout>
      </>
    ),
  },
  {
    path: "/privacidad",
    element: (
      <>
        <title>YMC | Privacidad</title>
        <B2BLayout><PrivacyPage /></B2BLayout>
      </>
    ),
  },
  {
    path: "/terminos",
    element: (
      <>
        <title>YMC | Términos</title>
        <B2BLayout><TermsPage /></B2BLayout>
      </>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="373324863794-24umjtie522qdma9b4kro9lg8q7804nj.apps.googleusercontent.com">
    <RouterProvider router={Router} />
  </GoogleOAuthProvider>
);

const SendAnalytics = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
  });
};

reportWebVitals(SendAnalytics);
